import Aside from "../components/home/aside/Aside";
import PostGrid from "../components/home/PostsGrid";

export default function Home() {
  return (
    <section className="wrapper">
      <Aside />
      <PostGrid />
    </section>
  )
}